import { SIDEBAR_GAME_TAB } from '../constants/sidebar';

const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
const CHANGE_SELECTED_TAB = 'CHANGE_SELECTED_TAB';
const ENABLE_TOGGLE = 'ENABLE_TOGGLE';
const DISABLE_TOGGLE = 'DISABLE_TOGGLE';
export const RESET_SIDEBAR = 'RESET_SIDEBAR';

const INITIAL_STATE = {
  isCollapsed: false,
  toggleDisabled: true,
  selectedTab: SIDEBAR_GAME_TAB,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CHANGE_SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.payload,
      };
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        isCollapsed: !state.isCollapsed,
      };
    case ENABLE_TOGGLE:
      return {
        ...state,
        toggleDisabled: false,
      };
    case DISABLE_TOGGLE:
      return INITIAL_STATE;
    case RESET_SIDEBAR:
      return INITIAL_STATE;
    default:
      return state;
  }
}

export function toggleSidebar() {
  return { type: TOGGLE_SIDEBAR };
}

export function changeSelectedTab(name) {
  return {
    type: CHANGE_SELECTED_TAB,
    payload: name,
  };
}

export function disableToggle() {
  return { type: DISABLE_TOGGLE };
}

export function enableToggle() {
  return { type: ENABLE_TOGGLE };
}
